import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Head = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vizox - Immigration Visa Consulting</title>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Helmet>
    </HelmetProvider>
  );
};

export default Head;